var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 6.01148C5.87926 6.01148 5.76709 5.99223 5.66326 5.95373C5.55942 5.91524 5.46067 5.84924 5.36701 5.75573L0.872758 1.26149C0.734425 1.12299 0.663591 0.948902 0.660258 0.739235C0.657091 0.529735 0.727925 0.352484 0.872758 0.207484C1.01776 0.0626511 1.19342 -0.00976562 1.39976 -0.00976562C1.60609 -0.00976562 1.78176 0.0626511 1.92676 0.207484L5.99976 4.28074L10.0728 0.207484C10.2113 0.0691511 10.3853 -0.00168223 10.595 -0.00501556C10.8045 -0.00818223 10.9818 0.0626511 11.1268 0.207484C11.2716 0.352484 11.344 0.528152 11.344 0.734485C11.344 0.940818 11.2716 1.11649 11.1268 1.26149L6.63251 5.75573C6.53884 5.84924 6.44009 5.91524 6.33626 5.95373C6.23242 5.99223 6.12026 6.01148 5.99976 6.01148Z",
    fill: "#6A7878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down.18fa337795cba953d860d74b889ddd66.svg";
export { ForwardRef as ReactComponent };